// Re-exports from unified color system
import { MOBILE_LIGHT_COLORS } from '../residentColors';

export const RESIDENTS_MOBILE_COLORS = {
  BACKGROUND_PRIMARY: MOBILE_LIGHT_COLORS.background,
  TEXT_PRIMARY: MOBILE_LIGHT_COLORS.textPrimary,
  TEXT_SECONDARY: MOBILE_LIGHT_COLORS.textSecondary,
  TEXT_TERTIARY: MOBILE_LIGHT_COLORS.textTertiary,
  BUTTON_PRIMARY: MOBILE_LIGHT_COLORS.buttonPrimary,
  BUTTON_SECONDARY: MOBILE_LIGHT_COLORS.buttonSecondary,
  BORDER_PRIMARY: MOBILE_LIGHT_COLORS.borderPrimary,
  AVATAR_BACKGROUND: MOBILE_LIGHT_COLORS.avatarBackground,
} as const;
